export default function NotFound() {
    return (
      <div className="p-10">
        <h1>404 - Página no encontrada</h1>
      </div>
    );
  }
  